/* Lodash shim — replaces 73KB lodash.js with ~2KB of only used functions */
(function(root) {
  var _ = {};
  _.assignIn = _.extend = function(obj) {
    for (var i = 1; i < arguments.length; i++) {
      var src = arguments[i];
      if (src) for (var k in src) obj[k] = src[k];
    }
    return obj;
  };
  _.find = function(arr, fn) {
    if (!arr) return undefined;
    if (typeof fn === 'object') { var props = fn; fn = function(o) { for (var k in props) { if (o[k] !== props[k]) return false; } return true; }; }
    for (var i = 0; i < arr.length; i++) if (fn(arr[i], i, arr)) return arr[i];
    return undefined;
  };
  _.findIndex = function(arr, fn) {
    if (!arr) return -1;
    if (typeof fn === 'object') { var props = fn; fn = function(o) { for (var k in props) { if (o[k] !== props[k]) return false; } return true; }; }
    for (var i = 0; i < arr.length; i++) if (fn(arr[i], i, arr)) return i;
    return -1;
  };
  _.filter = function(arr, fn) {
    if (!arr) return [];
    if (typeof fn === 'object') { var props = fn; fn = function(o) { for (var k in props) { if (o[k] !== props[k]) return false; } return true; }; }
    var r = []; for (var i = 0; i < arr.length; i++) if (fn(arr[i], i, arr)) r.push(arr[i]); return r;
  };
  _.map = function(arr, fn) {
    if (!arr) return [];
    var r = []; for (var i = 0; i < arr.length; i++) r.push(fn(arr[i], i, arr)); return r;
  };
  _.compact = function(arr) { return arr ? arr.filter(Boolean) : []; };
  _.isUndefined = function(v) { return v === undefined; };
  _.isFunction = function(v) { return typeof v === 'function'; };
  _.escape = function(s) {
    if (!s) return '';
    var map = {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'};
    return String(s).replace(/[&<>"']/g, function(c) { return map[c]; });
  };
  _.isEqual = function(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (typeof a !== typeof b) return false;
    if (typeof a !== 'object') return a === b;
    var ka = Object.keys(a), kb = Object.keys(b);
    if (ka.length !== kb.length) return false;
    for (var i = 0; i < ka.length; i++) if (!_.isEqual(a[ka[i]], b[ka[i]])) return false;
    return true;
  };
  root._ = _;
})(typeof window !== 'undefined' ? window : this);
